var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon-button-arrow",attrs:{"xmlns":"http://www.w3.org/2000/svg","version":"1.1","viewBox":"0 0 37 11"}},[_c('path',{attrs:{"fill":"currentColor","id":"arrow-line","d":"M29.9 4.4h4.9v2h-4.9v-2z"}}),_c('path',{attrs:{"fill":"currentColor","d":"m27.6.4 9 5-9 5V.4z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }